<template>
    <div class="income_box">
        <div class="list" v-if="subRouteNames.includes('/PowerBI3')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(239, 175, 96, 0.4);background:rgba(239, 175, 96, 0.4)" @click="jumpToBI('PowerBI3')">
                <img src="../../assets/image/BI_4.png" alt="">
                <div class="name"><span>检测车型分析</span></div>
                <div class="content"><span>统计服务顾问的不同车型成交率、成交项目数占比、不同车型成交项目数分析</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/PowerBI4')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(74, 223, 147, 0.4);background:rgba(74, 223, 147, 0.4)" @click="jumpToBI('PowerBI4')">
                <img src="../../assets/image/BI_5.png" alt="">
                <div class="name"><span>项目里程分析</span></div>
                <div class="content"><span>统计服务顾问对不同里程区间的不同车型成交率、成交项目数占比、不同车型成交项目数分析</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/PowerBI9')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(168, 134, 205, 0.4);background:rgba(168, 134, 205, 0.4)" @click="jumpToBI('PowerBI9')">
                <img src="../../assets/image/BI_10.png" alt="">
                <div class="name"><span>检测日报分析</span></div>
                <div class="content"><span>统计服务顾问日销售成交台次趋势、成交项目数趋势、访问率趋势</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/PowerBI1')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(168, 134, 205, 0.4);background:rgba(168, 134, 205, 0.4)" @click="jumpToBI('PowerBI1')">
                <img src="../../assets/image/BI_6.png" alt="">
                <div class="name"><span>检测周报分析</span></div>
                <div class="content"><span>统计服务顾问某周期时段的销售成交台次趋势、成交项目数趋势</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/PowerBI2')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(245, 214, 158, 0.4);background:rgba(245, 214, 158, 0.4)" @click="jumpToBI('PowerBI2')">
                <img src="../../assets/image/BI_7.png" alt="">
                <div class="name"><span>检测月报分析</span></div>
                <div class="content"><span>统计服务顾问某月度时段销售态势分布、成交台次趋势、成交项目数趋势分析</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/PowerBI8')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(73, 171, 255, 0.4);background:rgba(73, 171, 255, 0.4)" @click="jumpToBI('PowerBI8')">
                <img src="../../assets/image/BI_9.png" alt="">
                <div class="name"><span>检测报告点击分析</span></div>
                <div class="content"><span>统计检测档案报告的点击次数、人员访问数占比、SA访问检测报告的分析</span></div>
            </a>
        </div>
        <div class="list" v-if="subRouteNames.includes('/compareBI3')">
            <a class="item" style="box-shadow: 0px 20px 30px rgba(168, 134, 205, 0.4);background:rgba(168, 134, 205, 0.4)" @click="jumpToBI('compareBI3')">
                <img src="../../assets/image/compareBI_3.png" alt="">
                <div class="name"><span>项目检出异常项</span></div>
                <div class="content"><span>按照检测分类方式对检测项目进行成交趋势、SA成交占比、车型成交占比、里程区间成交占比等做分析</span></div>
            </a>
        </div>
    </div>
</template>

<script>
  export default {
    name: "BIreport",
    data() {
      return {
        subRouteNames:[]
      };
    },
    created(){
      let navList = JSON.parse(sessionStorage.getItem("navList")).data
      let filterItem = navList.filter(item => {
        return item.routeName === '/BIreport'
      })
      const subRouteNames = filterItem[0].subMenu.map(obj => obj.subRouteName);
      this.subRouteNames = subRouteNames


    },
    methods:{
      jumpToBI(item){
        this.$router.replace({name:item})
        let routeInfo ={
          path: `/${item}`
        }
        sessionStorage.setItem("routeInfo", JSON.stringify(routeInfo));

        let showInfo = {
          showMenu: true,
          showData: false,
          showChart: true,
          showSystem: false,
          active_tab:'3',
          routeName: `/${item}`
        }
        sessionStorage.setItem("showInfo", JSON.stringify(showInfo));

      },
    },
  };
</script>

<style lang="less" scoped>
    .income_box {
        overflow: hidden;
        padding-top: 20px;
        padding-left: 5px;
        .list {
            padding: 0 15px 40px 15px;
            float: left;
            max-width: 360px;
            width: 17vw;
            height: 21vw;
            /*background: linear-gradient(132.59deg, #FF3B94 11.42%, #FFB02E 96.37%);*/
            .item {
                width: 100%;
                /*height: 400px;*/
                display: block;
                border-radius: 32px;
                overflow: hidden;
                position: relative;
                img {
                    width: 100%;
                }
                .name {
                    position: absolute;
                    top: 50%;
                    width: 100%;
                    text-align: center;
                    span {
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 140%;
                        line-height: 39px;
                        text-align: center;
                        color: #FFFFFF;
                    }
                }
                .content {
                    position: absolute;
                    left: 5%;
                    top: 64.75%;
                    width: 90%;
                    right: 5%;
                    span {
                        width: 100%;
                        height: 86px;
                        display: block;
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 70%;
                        line-height: 200%;
                        text-align: left;
                        color: #FFFFFF;
                        /*transform: scale(0.7);*/
                        /*-webkit-transform: scale(0.7);*/

                    }
                }
            }
        }
    }
</style>
